import { render, staticRenderFns } from "./ClientActionMenu.vue?vue&type=template&id=dad5c88c&"
import script from "./ClientActionMenu.vue?vue&type=script&lang=js&"
export * from "./ClientActionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports